import { Component, input } from '@angular/core';

@Component({
    selector: 'gea-svg-pencil',
    templateUrl: './pencil.component.html',
    standalone: false
})
export class PencilComponent {
    filled = input<boolean | undefined>()
    size = input<number>(16)
    tooltip = input<string | undefined>()
}
